import room from './room'
import rooms from './rooms'
import tabs from './tabs'
import widget from './widget'
import home from './home'
import login from './login'

export default {
  room,
  rooms,
  tabs,
  widget,
  home,
  login,
}
